import * as React from 'react';
import { SVGProps } from 'react';

const SvgLogoutOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}>
    <path
      d="M12.8 6a3 3 0 0 0-3-3H6.5a2.7 2.7 0 0 0-2.7 2.7v12.6A2.7 2.7 0 0 0 6.5 21h3.3a3 3 0 0 0 3-3v-1h-2v1a1 1 0 0 1-1 1H6.7a.9.9 0 0 1-.9-.9V5.9a.9.9 0 0 1 .9-.9h3.1a1 1 0 0 1 1 1v1h2V6Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.364 17.136a.9.9 0 0 1 0-1.272L19.227 12l-3.863-3.864a.9.9 0 0 1 1.273-1.272l4.5 4.5a.9.9 0 0 1 0 1.272l-4.5 4.5a.9.9 0 0 1-1.273 0Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.8 12a.9.9 0 0 1 .9-.9h10.8a.9.9 0 0 1 0 1.8H9.7a.9.9 0 0 1-.9-.9Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgLogoutOutlined;
